import { selectorFamily } from 'recoil';
import appointmentsState from '../atoms/appointments';
import { LegacyAppointment } from '../../interfaces/api/Collaborative';

const appointmentState = selectorFamily<LegacyAppointment, LegacyAppointment['id']>({
  key: 'appointment',
  get: (id) => ({ get }) => {
    const appointments = get(appointmentsState);
    return appointments[id];
  },
  set: (id) => ({ set }, newAppointment) =>
    set(appointmentsState, (prevState) => ({ ...prevState, [id]: newAppointment as LegacyAppointment })),
});

export { appointmentState };
